var _defs, _path, _path2, _rect, _circle, _circle2, _circle3, _circle4, _rect2, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC4WwwIconsWhiteHomeTheater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line_Work",
    "data-name": "Line Work",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C4_WWW_Icons_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.4,31.38a.49.49,0,0,1,.48.48V61.33a.49.49,0,0,1-.48.48H25.85a.48.48,0,0,1-.47-.48V31.86a.48.48,0,0,1,.47-.48H74.4m0-1H25.85a1.48,1.48,0,0,0-1.47,1.48V61.33a1.47,1.47,0,0,0,1.47,1.48H74.4a1.48,1.48,0,0,0,1.48-1.48V31.86a1.49,1.49,0,0,0-1.48-1.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.88,65.63v3H25.38v-3h49.5m.14-1H25.23a.85.85,0,0,0-.85.85v3.28a.86.86,0,0,0,.85.86H75a.87.87,0,0,0,.86-.86V65.48a.86.86,0,0,0-.86-.85Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.52,
    y: 48.56,
    width: 12.13,
    height: 21.05,
    rx: 1.72
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.56,
    cy: 53.81,
    r: 0.97
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.56,
    cy: 53.81,
    r: 3.06
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.56,
    cy: 62.85,
    r: 1.77
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 84.56,
    cy: 62.85,
    r: 4.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.35,
    y: 48.56,
    width: 12.13,
    height: 21.05,
    rx: 1.72
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.38,
    cy: 53.81,
    r: 0.97
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.38,
    cy: 53.81,
    r: 3.06
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.38,
    cy: 62.85,
    r: 1.77
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.38,
    cy: 62.85,
    r: 4.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4WwwIconsWhiteHomeTheater);
export default __webpack_public_path__ + "static/media/C4_WWW_Icons_White-Home-Theater.f165555f49853d9679f3cd73691665b2.svg";
export { ForwardRef as ReactComponent };